import Router from 'next/router';

import { SEARCH } from '../../constants/routes';
import { TYPE_VALUES } from '../../constants/search';
import { createLinkProps } from '../../utils/routing';

export const searchAndNavigate = (text: string) => {
  const { href, as } = createLinkProps('search', SEARCH, {
    queryParams: {
      text,
      searchType: TYPE_VALUES.NEWS,
    },
  });

  Router.push(href, as);
};

export const getPlaceholder = (isMobile: boolean) => (isMobile ? 'Поиск по Журналу' : 'Что ищете?');
